const ITEMS = ["Paris", "Côte d'Azur", "Genève", "Transferts Aéroport", "Séminaires", "Chauffeur privé 24/7", "Tarifs fixes", "Discrétion absolue"];

export const Marquee = () => (
  <div className="bg-obsidian text-cream/70 py-5 overflow-hidden border-y border-neutral-800" data-testid="editorial-marquee">
    <div className="flex w-max animate-marquee">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex shrink-0 items-center">
          {ITEMS.map((item, i) => (
            <span key={`${copy}-${i}`} className="flex items-center text-xs uppercase tracking-[0.3em] font-mono whitespace-nowrap">
              <span className="px-8">{item}</span>
              <span className="text-gold">•</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
